// API Configuration
const API_BASE_URL =
  "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net";

/**
 * Public app URL (post–Stripe Checkout redirect).
 * Create React App only inlines env vars prefixed with REACT_APP_.
 * Use REACT_APP_BASE_URL=https://app.thriftops.com (same value you would use for NEXT_PUBLIC_BASE_URL in Next.js).
 */
const APP_BASE_URL = (
  process.env.REACT_APP_BASE_URL || "https://app.thriftops.com"
).replace(/\/$/, "");

/**
 * Stripe publishable key (safe in the browser).
 * Set REACT_APP_STRIPE_PUBLISHABLE_KEY (same value as NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY elsewhere).
 * STRIPE_SECRET_KEY must only live on your backend — never in this frontend bundle.
 */
const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

/** Mirrors Next.js testMode: use test Stripe keys / URLs when true. */
const STRIPE_TEST_MODE =
  process.env.REACT_APP_STRIPE_TEST_MODE === "true" ||
  process.env.REACT_APP_STRIPE_TEST_MODE === "1";

const config = {
  API_BASE_URL,
  APP_BASE_URL,
  STRIPE_PUBLISHABLE_KEY,
  STRIPE_TEST_MODE,

  /**
   * Stripe Checkout Session (POST) — same contract as Next.js route using
   * price, email, plan, testMode, success_url, cancel_url, addons, signup_context.
   * Response: { success, url?, sessionId? }
   */
  STRIPE_CHECKOUT_SESSION_URL:
    process.env.REACT_APP_STRIPE_CHECKOUT_SESSION_URL ||
    `${API_BASE_URL}/api/stripe/create-checkout-session`,
};

export default config;